import { AnyAction } from 'redux';
import { AddVertragToAngebote, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, RsVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { RsActions } from '../rsActions';
import { Rechtsstreitigkeiten } from '../appState';

export const rechtsstreitigkeitenReducer = function (
  sectionState: Rechtsstreitigkeiten = null,
  action: AnyAction,
): Rechtsstreitigkeiten {
  switch (action.type) {
    case RsActions.RECHTSSTREITIGKEITEN_CHANGED: {
      return { anzahl: 0, vorhanden: action.payload };
    }
    case RsActions.ANZAHL_RECHTSSTREITIGKEITEN_CHANGED: {
      return { ...sectionState, anzahl: action.payload };
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (actionPayload.appId === App.RS && action.payload.vorvertragsNummern) {
        return { anzahl: 0, vorhanden: false };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: RsVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.RS && actionPayload.anzahlVorschaeden) {
        return {
          anzahl: actionPayload.anzahlVorschaeden,
          vorhanden: actionPayload.anzahlVorschaeden > 0,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
